import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Button, Menu } from '@pocketlaw/tetris';
import { ContextDialog } from './ContextDialog';
import { useApprovalCheck } from '../ApprovalCheckProvider';
export function RerunCheckButton() {
    const { rerunCheck } = useApprovalCheck();
    const [renderDialog, setRenderDialog] = useState(false);
    const showDialog = () => setRenderDialog(true);
    const hideDialog = () => setRenderDialog(false);
    const handleRerun = () => {
        hideDialog();
        rerunCheck();
    };
    const handleRerunWithContext = (context) => {
        rerunCheck(context);
    };
    return (<Fragment>
      {renderDialog && <ContextDialog onClose={hideDialog} onSubmit={handleRerunWithContext}/>}

      <Menu.Root target={<Button $stretch size="small" appearance="secondary">
            <Trans comment="Document approval check - Rerun check button label">Rerun check</Trans>
          </Button>}>
        <Menu.Item onClick={handleRerun}>
          <Menu.ItemText primary={t({
            comment: 'Document approval check - Rerun check button label',
            message: 'Rerun',
        })} secondary={t({
            comment: 'Document approval check - Rerun check button description',
            message: 'Rerun check with same prompt',
        })}/>
        </Menu.Item>

        <Menu.Item onClick={showDialog}>
          <Menu.ItemText primary={t({
            comment: 'Document approval check - Rerun check button label',
            message: 'Rerun with more context',
        })} secondary={t({
            comment: 'Document approval check - Rerun check button description',
            message: 'Rerun check with same prompt and more context',
        })}/>
        </Menu.Item>
      </Menu.Root>
    </Fragment>);
}
